import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import productImg from "../assets/img/product/product_1_1.jpg";
import productThumbImg from "../assets/img/product/product_thumb_1_1.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Header from "./header";
import axios from "axios";
import Swal from "sweetalert2";

export default function Cart() {
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [stockMap, setStockMap] = useState({});
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";
  const history = useHistory();

  useEffect(() => {
    // Fetch stock for all cart items
    const fetchStocks = async () => {
      const ids = cartItems.map((item) => item.productId);
      if (ids.length === 0) return;
      try {
        const responses = await Promise.all(
          ids.map((id) => axios.get(`${API_URL}/products/${id}`))
        );
        const map = {};
        console.log({responses});
        responses.forEach((res) => {
          map[res.data.id] = {
            saleStock: res.data.saleStock,
            rentalStock: res.data.rentalStock,
          };
        });
        setStockMap(map);
      } catch (err) {
        // ignore
      }
    };
    fetchStocks();
  }, [cartItems]);
  useEffect(() => {
    loadCartItems();
  }, []);
  const loadCartItems = () => {
    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    const items = JSON.parse(localStorage.getItem(cartKey) || "[]");
    setCartItems(items);
    calculateTotal(items);
  };
  const calculateTotal = (items) => {
    const total = items.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);
    setTotal(total);
  };
  const handleRemoveItem = (e,index) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this item from your cart?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedItems = cartItems.filter((_, i) => i !== index);
        setCartItems(updatedItems);
        const userId = localStorage.getItem("currentUserId");
        const cartKey = `cart_${userId}`;
        localStorage.setItem(cartKey, JSON.stringify(updatedItems));
        calculateTotal(updatedItems);
        // window.location.href = "/cart";
        history.push("/cart");
        Swal.fire(
          "Removed!",
          "Item has been removed from your cart.",
          "success"
        );
        window.dispatchEvent(new Event("cartUpdated"));
      }
    });
  };

  const handleQuantityChange = (index, newQuantity) => {
    if (newQuantity < 1) return;
    const item = cartItems[index];
    const stock = stockMap[item.productId] || {};
    const maxStock = item.type === "buy" ? stock.saleStock : stock.rentalStock;
    if (maxStock !== undefined && newQuantity > maxStock) {
      Swal.fire("Error", "Not enough stock available.", "error");
      return;
    }
    const updatedItems = [...cartItems];
    updatedItems[index].quantity = newQuantity;
    setCartItems(updatedItems);
    const userId = localStorage.getItem("currentUserId");
    const cartKey = `cart_${userId}`;
    localStorage.setItem(cartKey, JSON.stringify(updatedItems));
    calculateTotal(updatedItems);
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const handleCheckout = (e) => {
    e.preventDefault();
    // console.log("dfd");
    const outOfStock = cartItems.some((item) => {
      const stock = stockMap[item.productId] || {};
      const maxStock =
        item.type === "buy" ? stock.saleStock : stock.rentalStock;
      return !maxStock || item.quantity > maxStock;
    });
    if (outOfStock) {
      Swal.fire(
        "Error",
        "One or more items are out of stock. Please update your cart.",
        "error"
      );
      return;
    }
    const token = localStorage.getItem("userToken");
    if (!token) {
      Swal.fire(
        "Login Required",
        "Please login to proceed to checkout.",
        "info"
      );
      return;
    }   
   
    history.push("/checkout");
  };
  return (
    <>
      <div class="sidemenu-wrapper shopping-cart ">
        <div class="sidemenu-content">
          <button class="closeButton sideMenuCls">
            <i class="far fa-times"></i>
          </button>
          <div class="widget woocommerce widget_shopping_cart">
            <h3 class="widget_title">Shopping cart</h3>
            <div class="widget_shopping_cart_content">
              <ul class="woocommerce-mini-cart cart_list product_list_widget ">
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_2.jpg"
                      alt="Cart Image2"
                    />
                    Pranarom Pure Essential Oil
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span>
                      $15.00
                    </span>
                  </span>
                </li>
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_3.jpg"
                      alt="Cart Image3"
                    />
                    Pediatric Stethoscope
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span>
                      $30.00
                    </span>
                  </span>
                </li>
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_4.jpg"
                      alt="Cart Image1"
                    />
                    Puregen Labs Allergy Relief
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span>
                      $55.00
                    </span>
                  </span>
                </li>
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_5.jpg"
                      alt="Cart Image2"
                    />
                    Digital Thermometer
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">$</span>
                      $15.99
                    </span>
                  </span>
                </li>
              </ul>
              <p class="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span class="woocommerce-Price-amount amount">
                  <span class="woocommerce-Price-currencySymbol">$</span>170.99
                </span>
              </p>
              <p class="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" class="th-btn wc-forward">
                  View cart
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div class="sidemenu-wrapper ">
        <div class="sidemenu-content">
          <button class="closeButton sideMenuCls">
            <i class="far fa-times"></i>
          </button>
          <div class="widget footer-widget mb-0">
            <div class="th-widget-about">
              <div class="about-logo">
                <Link to="index.html">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p class="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div class="widget footer-widget">
            <h3 class="widget_title">Recent Posts</h3>
            <div class="recent-post-wrap">
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image3"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>April
                      02, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image5"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>April
                      25, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image6"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image8"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="widget footer-widget">
            <h3 class="widget_title">Social Media:</h3>
            <div class="th-social">
              <Link to="https://facebook.com">
                <i class="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i class="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i class="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i class="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i class="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-search-box d-none d-lg-block">
        <button class="searchClose">
          <i class="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i class="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div class="th-menu-wrapper">
        <div class="th-menu-area text-center">
          <button class="th-menu-toggle">
            <i class="fal fa-times"></i>
          </button>
          <div class="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div class="th-mobile-menu">
            <ul>
              <li class="menu-item-has-children">
                <Link to="home-medical-clinic.html">Home</Link>
                <ul class="sub-menu">
                  <li class="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul class="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul class="sub-menu">
                  <li class="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul class="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul class="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul class="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />
      {/* Breadcumb */}
      <div
        class="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div class="container">
          <div class="breadcumb-content">
            <h1 class="breadcumb-title">Cart Page</h1>
            <ul class="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Cart Page</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Cart Area */}
      <div class="th-cart-wrapper  space-top space-extra-bottom" style={{marginTop:"-70px"}}>
        <div class="container">
          <div class="woocommerce-notices-wrapper">
            <div class="woocommerce-message">Shipping costs updated.</div>
          </div>
          <form action="#" class="woocommerce-cart-form">
            <table class="cart_table">
              <thead>
                <tr>
                  <th class="cart-col-image">Image</th>
                  <th class="cart-col-productname">Product Name</th>
                  <th class="cart-col-price">Price</th>
                  <th class="cart-col-quantity">Quantity</th>
                  <th class="cart-col-total">Total</th>
                  <th class="cart-col-remove">Remove</th>
                </tr>
              </thead>
              <tbody name={console.log({ cartItems })}>
                {cartItems.map((element, index) => {
                  const stock = stockMap[element.productId] || {};
                  const maxStock =
                    element.type === "buy"
                      ? stock.saleStock
                      : stock.rentalStock;
                  const isOutOfStock = !maxStock || maxStock <= 0;
                  return (
                    <>
                      <tr class="cart_item">
                        <td data-title="Product">
                          <Link
                            class="cart-productimage"
                            to="shop-details.html"
                          >
                            <img
                              width="91"
                              height="91"
                              src={`https://sunrise-backend.sunrisemeditechsystems.com${element.image}`}
                              alt="Image1"
                            />
                          </Link>
                        </td>
                        <td data-title="Name">
                          <Link class="cart-productname" to="shop-details.html">
                            {element.name}
                          </Link>
                        </td>
                        <td data-title="Price">
                          <span class="amount">
                            <bdi>
                              <span>₹</span>
                              {element.price}
                            </bdi>
                          </span>
                        </td>
                        <td data-title="Quantity">
                          <div class="quantity">
                            <button
                              class="quantity-minus qty-btn"
                              onClick={() =>
                                handleQuantityChange(
                                  index,
                                  element.quantity - 1
                                )
                              }
                              disabled={element.quantity <= 1}
                            >
                              <i class="far fa-minus"></i>
                            </button>
                            <input
                              type="number"
                              class="qty-input"
                              value={element.quantity}
                              min="1"
                              max="99"
                            />
                            <button
                              class="quantity-plus qty-btn"
                              onClick={() =>
                                handleQuantityChange(
                                  index,
                                  element.quantity + 1
                                )
                              }
                              disabled={
                                isOutOfStock || element.quantity >= maxStock
                              }
                            >
                              <i class="far fa-plus"></i>
                            </button>
                          </div>
                        </td>
                        <td data-title="Total">
                          <span class="amount">
                            <bdi>
                              ₹{(element.price * element.quantity).toFixed(2)}
                            </bdi>
                          </span>
                        </td>
                        <td data-title="Remove">
                          <Link
                            to="#"
                            class="remove"
                            onClick={(e) => handleRemoveItem(e,index)}
                          >
                            <i class="fal fa-trash-alt"></i>
                          </Link>
                        </td>
                      </tr>
                    </>
                  );
                })}
                <tr>
                  <td colSpan="6" class="actions">
                    <Link to="/shop" class="th-btn">
                      Continue Shopping
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          <div class="row justify-content-end">
            <div class="col-md-8 col-lg-7 col-xl-6">
              <h2 class="h4 summary-title">Cart Totals</h2>
              <table class="cart_totals">
                <tbody>
                  <tr>
                    <td>Cart Subtotal</td>
                    <td data-title="Cart Subtotal">
                      <span class="amount">
                        <bdi>₹{total.toFixed(2)}</bdi>
                      </span>
                    </td>
                  </tr>
                  <tr class="shipping">
                    <th>Shipping and Handling</th>
                    {/* <td data-title="Shipping and Handling">
                      <ul class="woocommerce-shipping-methods list-unstyled">
                        <li>
                          <input
                            type="radio"
                            id="free_shipping"
                            name="shipping_method"
                            class="shipping_method"
                          />
                          <label htmlFor="free_shipping">Free shipping</label>
                        </li>
                        <li>
                          <input
                            type="radio"
                            id="flat_rate"
                            name="shipping_method"
                            class="shipping_method"
                            checked="checked"
                          />
                          <label htmlFor="flat_rate">Flat rate</label>
                        </li>
                      </ul>
                      <p class="woocommerce-shipping-destination">
                        Shipping options will be updated during checkout.
                      </p>
                      <form action="#" method="post">
                        <Link to="#" class="shipping-calculator-button">
                          Change address
                        </Link>
                        <div class="shipping-calculator-form">
                          <p class="form-row">
                            <select class="form-select">
                              <option value="AR">Argentina</option>
                              <option value="AM">Armenia</option>
                              <option value="BD" selected="selected">
                                Bangladesh
                              </option>
                            </select>
                          </p>
                          <p>
                            <select class="form-select">
                              <option value="">Select an option…</option>
                              <option value="BD-05">Bagerhat</option>
                              <option value="BD-01">Bandarban</option>
                              <option value="BD-02">Barguna</option>
                              <option value="BD-06">Barishal</option>
                            </select>
                          </p>
                          <p class="form-row">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Town / City"
                            />
                          </p>
                          <p class="form-row">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Postcode / ZIP"
                            />
                          </p>
                          <p>
                            <button class="th-btn">Update</button>
                          </p>
                        </div>
                      </form>
                    </td> */}
                    <td>Free Shipping</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="order-total">
                    <td>Order Total</td>
                    <td data-title="Total">
                      <strong>
                        <span class="amount">
                          <bdi>₹{total.toFixed(2)}</bdi>
                        </span>
                      </strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div class="wc-proceed-to-checkout mb-30">
                <button
                className="th-btn"
                  style={{
                    flex: 1,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    textAlign: "center",
                  }}
                  onClick={(e) => handleCheckout(e)}
                  // disabled={cartItems.some((item) => {
                  //   const stock = stockMap[item.productId] || {};
                  //   const maxStock =
                  //     item.type === "buy" ? stock.saleStock : stock.rentalStock;
                  //   return !maxStock || item.quantity > maxStock;
                  // })}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
